import { ExternalLink, Phone, MapPin, Users } from "lucide-react";

const PARTNERS = [
  {
    name: "VTC29",
    phone: "0761847757",
    phoneDisplay: "07 61 84 77 57",
    vehicle: "VAN — 7 places",
    location: "Plabennec",
    website: "https://www.vtc29brest.fr",
    websiteDisplay: "vtc29brest.fr",
  },
  {
    name: "EVASION VTC",
    phone: "0777081800",
    phoneDisplay: "07 77 08 18 00",
    vehicle: "Berline — 4 passagers",
    location: "Brest",
    website: "https://www.evasion-vtc.fr",
    websiteDisplay: "evasion-vtc.fr",
  },
  {
    name: "TRANSPORTS UGUEN",
    phone: "0684239033",
    phoneDisplay: "06 84 23 90 33",
    vehicle: "Berline — 4 places",
    location: "Lesneven",
    website: "https://www.transportsuguen.com",
    websiteDisplay: "transportsuguen.com",
  },
];

export default function PartnersSection() {
  return (
    <section
      id="partenaires"
      data-testid="partners-section"
      className="relative py-24 lg:py-32 bg-[#161616]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-20 text-center">
          <p className="font-accent italic text-gold text-base tracking-widest mb-4">
            Notre réseau
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
            Nos Partenaires
          </h2>
          <div className="gold-line w-24 mx-auto mt-8" />
          <p className="text-white/40 text-sm mt-6 max-w-lg mx-auto tracking-wide font-light">
            Un réseau de chauffeurs professionnels en Finistère pour répondre à toutes vos demandes de transport.
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {PARTNERS.map((partner, idx) => (
            <div
              key={idx}
              data-testid={`partner-card-${idx}`}
              className="group relative bg-[#1E1E1E] border border-white/[0.08] hover:border-gold/40 transition-all duration-500 p-8 flex flex-col"
            >
              {/* Partner Name */}
              <h3 className="font-display text-xl text-white group-hover:text-gold transition-colors duration-300 mb-6">
                {partner.name}
              </h3>

              <div className="flex flex-col gap-4 flex-1">
                {/* Vehicle */}
                <div className="flex items-center gap-3">
                  <Users size={16} className="text-gold/60" strokeWidth={1.5} />
                  <span className="text-white/60 text-sm tracking-wide">
                    {partner.vehicle}
                  </span>
                </div>

                {/* Location */}
                <div className="flex items-center gap-3">
                  <MapPin size={16} className="text-gold/60" strokeWidth={1.5} />
                  <span className="text-white/60 text-sm tracking-wide">
                    {partner.location}
                  </span>
                </div>

                {/* Phone */}
                <a
                  href={`tel:${partner.phone}`}
                  data-testid={`partner-phone-${idx}`}
                  className="flex items-center gap-3 hover:text-gold transition-colors"
                >
                  <Phone size={16} className="text-gold/60" strokeWidth={1.5} />
                  <span className="text-white/80 text-sm tracking-wider">
                    {partner.phoneDisplay}
                  </span>
                </a>
              </div>

              {/* Website link */}
              <a
                href={partner.website}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`partner-website-${idx}`}
                className="mt-6 pt-6 border-t border-white/5 flex items-center justify-between text-sm text-white/40 hover:text-gold transition-colors duration-300"
              >
                <span className="tracking-wide">{partner.websiteDisplay}</span>
                <ExternalLink size={14} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
